import React from "react";
import {Link} from "react-router-dom";
import {useOktaAuth} from "@okta/okta-react";
import {
	OktaAuth,
	OktaAuthOptions,
	TokenManagerInterface,
	AccessToken,
	IDToken,
	UserClaims,
	TokenParams,
} from "@okta/okta-auth-js";
import {useOktaReducer} from "../../store/okta";
import Logo from "../../assets/FullLogo_Transparent_NoBuffer.png";
import "./style.scss";

const SideBar = () => {
	const {oktaAuth} = useOktaAuth();

	const handleLogout = async () => {
		await oktaAuth.signOut({
			postLogoutRedirectUri: window.location.origin,
		});
	};

	return (
		<div className="sidebar">
			<div className="logo">
				<img src={Logo} alt="logo" />
				<p style={{fontSize: "12px", fontWeight: "600", paddingTop: "5px", textAlign: "center"}}>Environment: {process.env.REACT_APP_ENV === "DEV" ? "Development" : "Production"}</p>
			</div>
			<ul>
				<Link to="/">
					<li>Overview</li>
				</Link>
				<Link to="/global-inventory-report">
					<li>Global Inventory Report</li>
				</Link>
				<Link to="/case-efficiency-ledger">
					<li>Case Efficiency Ledger</li>
				</Link>
				<Link to="/basic-settings">
					<li>Settings</li>
				</Link>
				<li
					onClick={() => {
						handleLogout();
					}}
				>
					Log Out
				</li>
			</ul>
		</div>
	);
};

export default SideBar;
